import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CoreService } from '../_core/services/core.service';
import { MenuLeftComponent } from './components/menu-left/menu-left.component';
import { MenuLeftService } from './components/menu-left/services/menu-left.service';
import { MenuTopComponent } from './components/menu-top/menu-top.component';

@Component({
    selector: 'platform-core',
    templateUrl: 'platform-core.page.html',
    styleUrl: 'platform-core.page.scss',
    imports: [RouterOutlet, MenuTopComponent, MenuLeftComponent],
})
export class PlatformCorePage implements OnInit {
    // * [Injects]
    private _coreService = inject(CoreService);
    public menuLeftService = inject(MenuLeftService);

    ngOnInit(): void {
        this._coreService.initAllGlobalRequests();
    }
}
